import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Avatar from '../Avatar/Avatar';
import Button from '../Button';
import ModalWrapper from '../ModalWrapper';
import QmImage from '../Image/QmImage';

import ownStyles from './StartingPromptModal.scss';
import qmStyles from '../../theme/qmStyles';

const logoSize = 96;

const StartingPromptModal = ({
  inviteData,
  isOpen,
  closeModal = () => {},
  onNext,
}) => (
  // currently only one case: BOQ invite
  <ModalWrapper
    isOpen={isOpen}
    additionalClassName={classNames(
      'QmModalContainer',
      ownStyles.modalContainer,
    )}
    closeModal={() => {}}
  >
    {// TODO: remove this unneeded render pattern
    // https://quarter.atlassian.net/browse/QP-2405
    () => (
      <div className="flex-1 flex-col items-center justify-between text-center p-double-gutter p-horizontal-triple-gutter">
        <div className="flex-col items-center">
          <div
            style={{ height: logoSize, width: logoSize }}
            className="relative mb-triple-gutter"
          >
            <div className={ownStyles.qmImage}>
              <Avatar
                size={logoSize}
                user={{ image: 'static/logos/qm_green_bg.png' }}
                shape="CIRCLE"
              />
            </div>
            <div className={ownStyles.senderImage}>
              <Avatar size={logoSize} user={inviteData.sender} shape="CIRCLE" />{' '}
            </div>
          </div>
          <span className="text-28 font-medium mb-gutter">
            Let's Get Started
          </span>
          <span className="text-20 color-grey-medium mb-double-gutter">
            With Quartermaster, see only verified reviews, work with vetted Pros
            and run smoother projects with the help of a dedicated team member.
          </span>
          {!!inviteData.starting_prompt.promotion_card && (
            <PromotionCard
              promotionCardData={inviteData.starting_prompt.promotion_card}
            />
          )}
        </div>
        <div>
          <Button
            hideBorder
            backgroundColor={qmStyles.qmBabyGreen}
            textColor={qmStyles.white}
            className="p-horizontal-quad-gutter"
            type="button"
            text="Sign up to Confirm"
            onClick={() => {
              onNext();
              closeModal();
            }}
          />
        </div>
      </div>
    )}
  </ModalWrapper>
);

export default StartingPromptModal;

StartingPromptModal.propTypes = {
  inviteData: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

const PromotionCard = ({ promotionCardData }) => {
  const { text, image, backgroundColor, textColor } = promotionCardData;

  return (
    <div
      className="flex-row items-center p-gutter mb-double-gutter text-left rounded-double"
      style={{ backgroundColor }}
    >
      <QmImage
        src={image}
        width={48}
        height={48}
        className="mr-gutter"
        style={{ height: 48 }}
      />
      <span className="text-16 font-medium " style={{ color: textColor }}>
        {text}
      </span>
    </div>
  );
};

PromotionCard.propTypes = {
  promotionCardData: PropTypes.object.isRequired,
};
